module.exports = __webpack_public_path__ + "img/Insert1.ab59fb45.jpg";